import React from 'react';

// Dx - xxx (fromDB_var)
type Tprops_Dx = { pass: { A: any; B: any; C: any; D: any; args: any } };
export const Dx = (props: Tprops_Dx) => {
  const { A, B, C, D, args } = props.pass;
  return <></>;
};
